import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "explore-map-with-image"
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]

import { Icon } from '../../Atoms';


export default /*@__PURE__*/_defineComponent({
  __name: 'ExploreMapButton',
  props: {
    onClick: { type: Function },
    disabled: { type: Boolean },
    hasPlaceholderImage: { type: Boolean },
    imageSrc: {},
    imageAlt: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.hasPlaceholderImage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _ctx.imageSrc,
            loading: "lazy",
            class: "backgroundImage",
            alt: _ctx.imageAlt
          }, null, 8, _hoisted_2),
          _createElementVNode("button", {
            class: _normalizeClass(["explore-map", {disabled: _ctx.disabled}]),
            disabled: _ctx.disabled,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
          }, [
            _createVNode(_unref(Icon), {
              "icon-name": "mapIcon",
              class: "map-icon",
              alt: ""
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("Explore map")), 1)
          ], 10, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.hasPlaceholderImage)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: _normalizeClass(["explore-map", {disabled: _ctx.disabled}]),
          disabled: _ctx.disabled,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
        }, [
          _createVNode(_unref(Icon), {
            "icon-name": "mapIcon",
            class: "map-icon",
            alt: ""
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("Explore map")), 1)
        ], 10, _hoisted_4))
      : _createCommentVNode("", true)
  ], 64))
}
}

})